import { render, staticRenderFns } from "./Cube.vue?vue&type=template&id=c37b593c&scoped=true&"
import script from "./Cube.vue?vue&type=script&lang=ts&"
export * from "./Cube.vue?vue&type=script&lang=ts&"
import style0 from "./Cube.vue?vue&type=style&index=0&id=c37b593c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37b593c",
  null
  
)

component.options.__file = "Cube.vue"
export default component.exports